<template>
    <div class="container">
        <div class="row mt-5" v-if="!cartItems.length" v-show="menuId">
            <div class="col-sm-12">
                <div class="text-center text-muted">
                    <h1 class="h4">There is no item in your cart</h1>
                    <h1 class="h6">
                        <router-link :to="{name: 'Home'}">Continue ordering</router-link>
                    </h1>
                </div>
            </div>
        </div>    
        <div class="row" v-else>
            <div class="col-md-8">
                <div class="row mt-3 mb-3">
                    <div class="col-sm-12 mb-3">
                        <router-link to="/"><i class="fas fa-chevron-left"></i> Return to Menu</router-link>
                    </div>
                    <div class="col-sm-12">
                        <b-card class="shadow">
                            <store-info></store-info>
                        </b-card>    
                    </div>
                    <div class="col-sm-12 my-3">
                        <b-card class="shadow">
                            <b-card-text>
                                <h6>{{ userInfo.name }}</h6>
                                <h6>{{ userInfo.phone | phone }}</h6>
                                <h6 class="text-capitalize">{{ userInfo.action }}</h6>
                            </b-card-text>    
                            <a href="#" 
                                @click.prevent="openUserInfoModal" 
                                class="custom-card-action">
                                <b-icon icon="pencil"></b-icon>
                            </a>
                        </b-card>
                    </div>
                    
                    <div class="col-sm-12">
                        <h5>Tip</h5>
                        <div class="row">
                            <div 
                                class="col-sm-3 d-none d-sm-block"
                                v-for="(tip, index) in tips"
                                :key="`tip-${index}`">
                                <b-card
                                    :title="tipTitle(tip)"
                                    class="tip-card"
                                    :class="{'active': tip.price == tipPrice}"
                                    @click="selectTip(tip, index)">
                                    <h6 v-if="tip.percent && tip.price > 0">
                                        {{ tip.price | currency }}
                                    </h6>
                                </b-card>
                            </div>                                                       
                        </div>
                        <div class="d-block d-sm-none">
                            <ul class=" nav nav-pills nav-fill">
                                <li class="nav-item"
                                    v-for="(tip, index) in tips"
                                    :key="`pills-${index}`">
                                    <p 
                                        class="nav-link" 
                                        :class="{'active': tip.price == tipPrice}"
                                        @click="selectTip(tip, index)" >{{tipTitle(tip)}}</p>
                                </li>
                            </ul>                          
                        </div>
                        <div class="d-flex my-3">
                            <label style="min-width: fit-content" class="mr-2">Tip Other Amount</label>
                            <b-form-input type="number" v-model="tipPrice" min="0" step="0.01" ref="tipInput" @keypress="isNumber($event)"></b-form-input>
                        </div>
                        <payment-form
                            v-if="paymentSystem === 'square'"
                            :tipAmount="parseFloat(tipAmount)"
                            :cartTax="cart_tax()"
                            :checkoutTotal="checkoutTotal"
                            :payableAmount="payableAmount"
                            :disableSts="isPaymentSubmitting"                         
                            @on-nonce="submitPayment">                            
                        </payment-form>                    
                        <payment-form-stripe 
                            v-if="paymentSystem === 'stripe'"
                            :payableAmount="payableAmount" 
                            @on-submit="onSubmitStripePayment"/>
                        <b-button
                            v-if="paymentSystem === 'kiosk'"
                            class="w-100"
                            variant="primary"
                            @click="kioskPay">Pay {{payableAmount | currency}}</b-button>
                    </div>                    
                </div>
            </div>
            <div class="col-md-4 d-none d-md-block">
                <div class="content" id="width-of-sidebar"></div>
                <shopping-cart 
                    @editCartItem="edit_cart_item"
                    type="total" />
            </div>
        </div>
        <b-modal 
		  	id="c-auth-modal" 
			centered 
			:hide-footer="true">
			<user-info 
				:user="userInfo"
				@close="closeUserInfoModal">
			</user-info>
		</b-modal>
        <product-modal 
            v-if="isShowProduct"
            :data_item="modal_item"
            :cart-item-index="modal_cart_item_index"
            @close="closeModal"/>        
        <b-modal 
		  	id="error-checkout-modal" 
			centered
            hide-footer
            title="Error">
            <div class="px-3">
                <div class="text-center mb-3">
                    <b-icon icon="exclamation-circle" font-scale="4" variant="danger"></b-icon>
                    <p class="text-danger my-3">{{ errMsg }}</p>
                </div>
            </div>    
		</b-modal>        
    </div>
</template>

<script>

import {mapState} from 'vuex'

import StoreInfo from '@/components/menu/StoreInfo'
// import PrettyCheck from 'pretty-checkbox-vue/check';
import ShoppingCart from "@/components/menu/ShoppingCart"
import UserInfo from '@/components/menu/UserInfo'
import ProductModal from '@/components/menu/ProductModal'
import PaymentForm from '@/components/menu/PaymentForm'
import PaymentFormStripe from '@/components/menu/PaymentFormStripe'

export default {
    name: 'Checkout',
    components: {
        // 'p-check': PrettyCheck,
        StoreInfo,
        ShoppingCart,
        UserInfo,
        ProductModal,
        PaymentForm,
        PaymentFormStripe
    },
    data()
    {
        return {
            stripeTimeoutID:null,
            isPaymentSubmitting:false,
            tipIndex: '',
            tipPrice: 0,
            isShowProduct: false,
            modal_item: null,
            modal_cart_item_index: null,
            errMsg: ''           
        }
    },

    computed: {
        ...mapState({
            userInfo: 'userInfo',
            menuId: 'menuId',
            tR: 'tipRules',
            orderPendingId: 'orderPendingId'
        }),
        paymentSystem(){
            return this.$store.getters.getState.paymentSystem || "";
        },
        cartItems(){
            return this.$store.getters.cartItems;
        },

        cartTotal(){
            return this.$store.getters.cartTotal;
        },

        checkoutTotal(){
            return this.cartTotal.sum;
        },
   
        tips()
        {
            var resp = []           
            let limit =  this.tR.limit === undefined ? 0 : this.tR.limit            
            let amounts = this.tR.amounts === undefined ? [] : this.tR.amounts
            let percents =  this.tR.percents === undefined ? [] : this.tR.percents

            resp.push({percent: 0, price:0})
            if(limit !== 0 && amounts.length > 0 && percents.length > 0){            
                if(this.cartTotal.sum <= limit){                    
                    amounts.forEach(amount=>{
                        if(amount > 0){
                            resp.push({
                                percent: null,
                                price: +(amount/100).toFixed(2)
                            })
                        }
                    })
                } else {                    
                    percents.forEach(percent=>{
                        if(percent > 0){
                            resp.push({
                                percent: (percent/100.0).toFixed(2),
                                price: (((this.cartTotal.sum/100.0) * (percent / 100.0))/100.0).toFixed(2)
                            })
                        }
                    })                    
                }   
            }else{
                [15, 20, 25].forEach(percent => {
                    resp.push({
                        percent: percent,
                        price: ((this.cartTotal.sum * percent / 100.0)/100.0).toFixed(2)
                    })
                })
            }            
            return resp
        },

        getState(){
            return this.$store.getters.getState;
        },

        tipAmount() {
            return this.$store.getters.tipAmount
        }, 

        payableAmount(){
            let taxRate1 = this.getState.tax
            let taxRate2 = this.getState.tax2
            return  this.checkoutTotal/100.0 + ((this.checkoutTotal * taxRate1)/10000.0) + ((this.checkoutTotal * taxRate2)/10000.0) + (this.tipAmount?parseFloat(this.tipAmount):0)
        }
    }, 
    created(){
        this.$store.dispatch('lsOSinCheckout')
 		window.addEventListener('hashchange', this.hash_change)
    },
    destroyed: function () {
        window.removeEventListener('hashchange', this.hash_change)
    },
    mounted()
    {
        //
        this.tipPrice = this.tipAmount        
    },

    watch: {
        tipPrice(val) {
            this.$store.dispatch('setTipAmount', val)
        },
        isShowProduct(){
            if(!this.isShowProduct && window.location.hash === "#/ProductModal"){
                history.back()
            }
		}
    },

    methods: {
        hash_change(hash){            
            let oldURL = new URL(hash.oldURL)
            let newURL = new URL(hash.newURL)
            if(newURL.hash === "#/checkout" && oldURL.hash === "#/ProductModal"){
                this.closeModal()
            }
        },
        tipTitle(tip){
            if(tip.percent === 0){
                return 'No Tip'
            } else if(tip.percent != null){
                return `${tip.percent}%`
            }else{
                return `$${tip.price}`
            }
        },
        select_tip(tip)
        {
            this.tip = tip.price;
        },

        cart_tax()
        {
            var calculate1 = Math.round(this.cartTotal.sum && this.getState.tax ? this.cartTotal.sum * this.getState.tax : 0);
            var calculate2 = Math.round(this.cartTotal.sum && this.getState.tax2 ? this.cartTotal.sum * this.getState.tax2 : 0);
            return calculate1 + calculate2;
        },

        checkout_total()
        {
            var calculate = (this.cartTotal.sum + this.cart_tax()) / 100;
            calculate += Number(this.tip);
            calculate = +calculate.toFixed(2);

            return calculate;
        },
        openUserInfoModal() {
            this.$bvModal.show('c-auth-modal')
        },
        closeUserInfoModal() {
            this.$bvModal.hide('c-auth-modal')
        },
        selectTip(item, index) {
            this.tipIndex = index
            this.tipPrice = item.price
        },
        edit_cart_item(index) {
            var cartItem = this.$store.getters.cartItems.find( (item,i) => i == index )
            this.modal_item = cartItem.item;
            this.modal_cart_item_index = index;
            this.isShowProduct = true
        },		
        closeModal() {
            this.isShowProduct = false
        },
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },        
        submitPayment(nonce, cardData) {
            let payload = {
                tipAmount: this.tipPrice,
                nonce: nonce,
                cardData:cardData
            }
            this.isPaymentSubmitting = true
            this.$store.dispatch('submitPayment', payload)
                .then((resp) => {
                    this.isPaymentSubmitting = false
                    if (resp.status === 'success') {
                        this.$store.dispatch('new_order')
                        this.$router.replace({name: "Home"}).catch(()=>{});                        
                        this.$router.push({name: 'OrderStatus', params: { orderId: resp.res._id }});
                        this.$store.dispatch('customerLog', "Payment, " + "Succeed " + `OrderId + ${resp.res._id}`);
                    }else{
                        this.$store.dispatch('customerLog', "Payment, " + "Failed");
                        this.errMsg = "Your card was declined, please try again."
                        this.$bvModal.show('error-checkout-modal')                        
                    }
                })
                .catch((err) => {
                    this.isPaymentSubmitting = false                    
                    this.errMsg = "Order error - "+err
                    this.$bvModal.show('error-checkout-modal')
                })            
        },
        onSubmitStripePayment() {
            this.$router.replace({name: "Home"}).catch(()=>{});                        
            this.$router.push({name: 'pendingOrderStatus', params: { pendingOrderId: this.orderPendingId }});            
            this.$store.dispatch('clearPendingOrder');            
        },
        kioskPay() {
            this.submitPayment("nonce", "carddata")

            //Add URL encode
            let linkBuilder = `clarenmenu://square/?`
            linkBuilder += `&total=${Math.floor(this.payableAmount * 100)}`
            linkBuilder += `&orderId=${this.orderPendingId}`

            window.location.href = linkBuilder
        }
    }
}
</script>

<style lang="scss" scoped>
    .card {
        &.shadow {
            box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)!important;
        }
        .custom-card-action {
            position: absolute;
            top: 1rem;
            right: 1rem;
        }
    }
    .tip-card {
        height: 100px;
        cursor: pointer;
        &:hover, &:active, &.active {
            box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)!important;
            background-color: #007bff;
            color: white;
        }
    }
    .nav-item p{
        box-shadow: 0 1px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)!important;
    }     
</style>